import React from "react";
import { useAppContext } from "../../helpers/account-context";
import { ICONS } from "../../helpers/helper";

const FilterOptions = (props) => {
  const { filters, onChangeSetting } = props;
  // https://codepen.io/smithsuth/pen/VvYzZP
  const { initedData: {hiddenFilters}, getLocale } = useAppContext()
  const isHiddenAll = !!hiddenFilters && hiddenFilters.indexOf('all') >= 0;

  if(isHiddenAll) return null;
  const isHiddenRadius = !!hiddenFilters && hiddenFilters.indexOf('radiuses') >= 0
  
  return  (
    <div className="cbmap-action-options">
      <div
        className={`cbmap-action-option-tags ${filters.tags && filters.tags.length > 0 ? 'is-filtering' : ''}`}
        onClick={(e) => onChangeSetting("tags")}
      >
        <div className="cbmap-action-option-name">
          {getLocale("show_filters")}
        </div>
        <div
          className="cbmap-caret"
          dangerouslySetInnerHTML={{ __html: ICONS.CARET }}
        />
      </div>
      {
        !isHiddenRadius && <div
        className="cbmap-action-option-radiuses"
        onClick={(e) => onChangeSetting("radius")}
      >
        <div className="cbmap-action-option-name">
          {filters.radius} {getLocale(filters.unit)}
        </div>
        <div
          className="cbmap-caret"
          dangerouslySetInnerHTML={{ __html: ICONS.CARET }}
        />
      </div>
      }
      
    </div>
  )
};

export default FilterOptions;
